var React = require('react');

function BlogIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m309 402v14h11.667l5.333 4v-4h3v-14zm2 2h16v10h-3v2l-2.666-2h-10.334z","fill":"#151e2d","fillRule":"evenodd","transform":"translate(-309 -402)"}));
}

BlogIcon.defaultProps = {"height":"18","viewBox":"0 0 20 18","width":"20"};

module.exports = BlogIcon;

BlogIcon.default = BlogIcon;
